import axios from 'axios'

const state = {
    itemsInCart: null,
    itemsForLater: null,
    cartItemsCount: null,
    cartItemsPriceSum: null,
}

const getters = {
    itemsInCart (state) {
        return state.itemsInCart
    },
    itemsForLater (state) {
        return state.itemsForLater
    },
    cartItemsCount (state) {
        return state.cartItemsCount
    },
    cartItemsPriceSum (state) {
        return state.cartItemsPriceSum
    },
    // console.log(Object.assign({}, activeUser))
}

const actions = {      
    async cartItemsPriceSumAction({ commit }) { 
        // fetch shopper items from cart if any
        let localStorageATCItemIds = JSON.parse(localStorage.getItem('ani_items_atc')) 
        if(localStorageATCItemIds && localStorageATCItemIds.length) {
            let cartItemsSum = 0
            // loop through all cart items and add up thier sum prices alone if available
            localStorageATCItemIds.forEach(cartItemElement => {
                if(cartItemElement.itemSumPrice){
                    cartItemsSum += parseInt(cartItemElement.itemSumPrice)
                }
            });
            return commit('CART_ITEMS_PRICE_SUM', cartItemsSum) 
        }
    },
    
    async cartItemsCountAction({ commit }) { 
        // fetch shopper items from cart if any
        let localStorageATCItemIds = JSON.parse(localStorage.getItem('ani_items_atc')) 
        let cartCount = 0
        if(localStorageATCItemIds) {
            cartCount = localStorageATCItemIds.length
        }
        // send back the total items counted in cart
        return commit('CART_ITEMS_COUNT', cartCount)
    },

    async fetchCartItemsAction({ commit }, cartObj) { 
        commit('ITEMS_IN_CART', null)
        let response = await axios.post(`/shopping-cart/cart-items`, cartObj)
        if(!response.data.error){
            commit('ITEMS_IN_CART', response.data.result)
        }
        return response.data
    },
    
    async fetchSavedLaterItemsAction({ commit }, savedLaterObj) { 
        commit('ITEMS_FOR_LATER', null)
        let response = await axios.post(`/saved-for-later/later-items`, savedLaterObj)
        if(!response.data.error){
            commit('ITEMS_FOR_LATER', response.data.result)
        }
        return response.data
    },
    
    async completeOrderAction({ dispatch }, orderObj) {
        var formData = new FormData();
        formData.append('shopperDetails', JSON.stringify(orderObj.shopperDetails))
        formData.append('shopperCart', JSON.stringify(orderObj.shopperCart))
        // append each uploaded photo as a files array 
        if(orderObj.photosArr){
            for(let x=0; x < orderObj.photosArr.length; x++){
                formData.append('paymentPhoto', orderObj.photosArr[x].path[x])
            }
        }
        let response = await axios.post(`/process-order/receive-order`, formData)
        if(!response.data.error && response.data.result && response.data.result.userId){
            let userObj = {
                userId: response.data.result.userId
            }
            // re-run fetch orders and addresses vuex actions to pull and display newly added data
            dispatch('fetchOrdersAction', userObj)
            dispatch('fetchAddressesAction', userObj)

            // only store the order result in local storage if noPasswordSet so when refreshed we don't loose the data
            let storeOrderResult = { orderNumber: response.data.result.orderNumber }
            if(response.data.result.noPasswordSet){
                storeOrderResult = {
                    orderNumber: response.data.result.orderNumber,
                    shopperEmail: response.data.result.receiverInfo.shopperEmail,
                    shopperConfToken: response.data.result.confToken,
                    shopperNoPwd: response.data.result.noPasswordSet
                }
            }
            localStorage.setItem('ani_items_sor', JSON.stringify(storeOrderResult))
        }
        return response.data
    },
}

const mutations = {
    ITEMS_IN_CART: (state, itemsInCart) => (state.itemsInCart = itemsInCart),
    ITEMS_FOR_LATER: (state, itemsForLater) => (state.itemsForLater = itemsForLater),
    CART_ITEMS_COUNT: (state, cartItemsCount) => (state.cartItemsCount = cartItemsCount),
    CART_ITEMS_PRICE_SUM: (state, cartItemsPriceSum) => (state.cartItemsPriceSum = cartItemsPriceSum)
}

export default {
    state,
    getters,
    actions,
    mutations
}